// removed by extract-text-webpack-plugin
module.exports = {"company-resolution-blockquote":"company-resolution-blockquote___127cK h4___kHWTn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ResolutionText/ResolutionText.css
// module id = 172
// module chunks = 0